// Segmented carrier-responses bar for the China requests list (#1442).
// Green answered segment, red rejected segment, leftover track = pending.
// Shared by the desktop row and the mobile card so both surfaces read the
// same. All data is already on the client via `r.carriers[].state`.
//
// @aiPurpose Replace the single-fill answers mini-bar with a proportional
//   two-colour bar plus a `responded/total` counter.
// @aiInvariant Accessibility is not colour-only: the track carries
//   `role="img"` + a localized breakdown `aria-label`/`title`, and the
//   monospace counter conveys the same `responded/total` ratio textually.
//   Colours come from CSS tokens only (no hardcoded hex).

import { useTranslation } from 'react-i18next';
import type { CarrierBid } from '../types.js';
import { summarizeCarrierResponses } from '../carrier-responses.js';
import { SegmentBar } from '../../../ui/index.js';

export function CarrierResponsesBar({ carriers }: { carriers: CarrierBid[] }) {
  const { t } = useTranslation('requests');
  const s = summarizeCarrierResponses(carriers);

  if (s.total === 0) {
    return <span style={{ color: 'var(--fg-4)', fontSize: 12 }}>—</span>;
  }

  const breakdown = t('list.answersBar.tooltip', {
    total: s.total,
    tariff: s.answered,
    rejected: s.rejected,
    pending: s.pending,
  });

  return (
    <SegmentBar
      total={s.total}
      answered={s.answered}
      rejected={s.rejected}
      ariaLabel={breakdown}
      testId="carrier-responses"
    />
  );
}
